<template>
	<transition name="modal-fade">
		<div class="modal-backdrop">
			<div class="modal-new mdl-dialog"
				aria-labelledby="modalTitle"
				aria-describedby="modalDescription"
				>
				<header v-if="header"
				class="modal-header"
				id="modalTitle"
				>
					<h3 name="header" class="mdl-dialog__title modal-new-title">
						{{{header | label}}}
					</h3>
					<button
					class="btn-close"
					type="button"
					aria-label="Close modal"
					@click="close()"
					>
						<span class="close fas fa-times fa-sm"></span>
					</button>
				</header>
				<section v-if="body"
				class="modal-body scrollbar"
				id="modalDescription"
				>
					<span name="body">
						{{{body | label}}}
					</span>
				</section>
				<footer
				class="modal-footer">
					<span name="footer">
						{{{footer | label}}}
					</span>
				</footer>
			</div>
		</div>
	</transition>
</template>

<script>
module.exports = {
  name: 'modal',
  props: ['header', 'body', 'footer', 'close'],
  ready: function () {
    console.log(this.header)
  },
  methods: {
    close: function () {
      this.$dispatch('closeModal')
    }
  }
}
</script>

<style>
	header.modal-header {
		width: auto;
	}
	.modal-backdrop {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: rgba(0, 0, 0, 0.3);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.modal-new {
		background: #FFFFFF;
		box-shadow: 2px 2px 20px 1px;
		overflow-x: auto;
		display: flex;
		flex-direction: column;
		width: 70%;
		height: 75%;
	}
	.modal-header,
	.modal-footer {
		padding: 15px;
		display: flex;
	}
	.modal-header {
		border-bottom: 1px solid #eeeeee;
		justify-content: space-between;
		color: white;
    align-items: center;
	}
	.modal-footer {
		border-top: 1px solid #eeeeee;
		justify-content: flex-end;
	}
	.modal-body {
		position: relative;
		padding: 20px 10px;
		text-align: left;
	}
	.btn-close {
		position: relative;
		float: right;
		border: none;
		font-size: 20px;
		padding: 20px;
		cursor: pointer;
		font-weight: bold;
		color: white;
		background: transparent;
	}
	.btn-green {
		color: white;
		background: #4AAE9B;
		border: 1px solid #4AAE9B;
		border-radius: 2px;
	}
	h3.modal-new-title {
		text-transform: uppercase;
    	color: white;
	}

</style>


// WEBPACK FOOTER //
// Modal.vue?3597132e